import React from 'react';
import {injectIntl} from "react-intl";
import Storage from "../../services/Storage";
import connect from "react-redux/es/connect/connect";
import {withAuthorization} from "../../services/Authorization";
import WeekDayTable from "./WeekDayTable";
import {SpinnerModal} from "../../public/components/SpinnerModal";

const MAX_SLOTS_TO_ADD = 3;

class OpeningHours extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openingHours: {
        dealerOpeningHours: {},
        bodyshopOpeningHours: {}
      }
    }
  }

  componentDidMount() {
    this.props.dispatchFetchOpeningHours();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.saveOpeningHours && nextProps.saveOpeningHours.openingHours && Object.keys(nextProps.saveOpeningHours.openingHours).length > 0) {
      this.setState({openingHours: nextProps.saveOpeningHours.openingHours});
    } else if (nextProps.fetchOpeningHours && nextProps.fetchOpeningHours.openingHours) {
      this.setState({openingHours: nextProps.fetchOpeningHours.openingHours});
    }
  };

  save = () => {
    this.props.dispatchSaveOpeningHours(this.state.openingHours);
  };

  onDataChange = (itemName, newData) => {
    const {openingHours} = this.state;
    openingHours[itemName] = newData;
    this.setState(openingHours);
  };

  render() {
    const {intl:{formatMessage}, loading, saveOpeningHours} = this.props;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';

    const {error: {content: errors ={}} = {}} = saveOpeningHours;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.opening-hours.title'})}
          </h2>
          {canWrite &&
            <div className="box-heading__button">
              <button onClick={this.save} disabled={loading} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
        {
          <div className="box__body">
            <SpinnerModal visible={loading}/>
            <div className="row">
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'section.dealerOpeningHours.title'})}</h3>

                <WeekDayTable data={this.state.openingHours.dealerOpeningHours}
                              onChange={(newData) => this.onDataChange('dealerOpeningHours', newData)}
                              dataName={'dealerOpeningHours'} maxSlots={MAX_SLOTS_TO_ADD} errors={errors}
                />
              </div>

              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'section.bodyshopOpeningHours.title'})}</h3>

                <WeekDayTable data={this.state.openingHours.bodyshopOpeningHours}
                              onChange={(newData) => this.onDataChange('bodyshopOpeningHours', newData)}
                              dataName={'bodyshopOpeningHours'} maxSlots={MAX_SLOTS_TO_ADD} errors={errors}
                />
              </div>
            </div>
          </div>
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchOpeningHours: state.fetchOpeningHours,
  saveOpeningHours: state.saveOpeningHours,
  loading: state.fetchOpeningHours.loading || state.saveOpeningHours.loading,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchOpeningHours: () => dispatch({type: 'FETCH_OPENING_HOURS.REQUEST'}),
  dispatchSaveOpeningHours: (body) => dispatch({type: 'SAVE_OPENING_HOURS.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(OpeningHours), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
